import DriveEndType from "../../enums/drive-end-type";
import OncePerPlayRule from "../../../common/once-per-play-rule";
import FootballState from "../../state/football-state";

export default class Turnover extends OncePerPlayRule {
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const startingPossession = play.getContextSnapshot().isHomePossession()
            ? gameContext.homeTeamId
            : gameContext.awayTeamId;
        const finalPossession = gameContext.getPossessionTeamId();

        return (
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            }) &&
            startingPossession !== finalPossession &&
            (!play.historyContains(FootballState.KickOff) ||
                (play.historyContains(FootballState.KickOff) &&
                    play.historyContains(FootballState.Fumble)))
        );
    }

    getDriveEndType(ruleContext, play) {
        let endType = DriveEndType.Unknown;
        if (ruleContext.isSafety) {
            endType = DriveEndType.Safety;
        } else if (ruleContext.isTouchdown) {
            endType = DriveEndType.TurnoverOnDefenseForTouchdown;
        } else if (this._isCleanPunt(play)) {
            // A clean punt (caught/returned/downed, no intervening fumble,
            // muff or penalty) is a change of possession but not a "turnover"
            // in the stat sense; classify the ending drive accordingly. Punts
            // with a fumble/muff recovery or a penalty-induced change stay a
            // generic turnover.
            endType = DriveEndType.Punt;
        } else {
            //TODO How to determine remaining end types (e.g. turnover on downs)
            endType = DriveEndType.Turnover;
        }

        return endType;
    }

    _isCleanPunt(play) {
        return (
            !!play?.historyContains(FootballState.Punt) &&
            !play.historyContains(FootballState.Fumble) &&
            !play.historyContains(FootballState.Muffed) &&
            !play.historyContains(FootballState.Penalty) &&
            !play.historyContains(FootballState.PlayPenalty)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.setDriveContext({
            triggerDrive: !ruleContext.isSafety,
            previousDriveEndType: this.getDriveEndType(ruleContext, play)
        });
        gameContext.currentDriveId = null;

        return [];
    }
}
